// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3v1bP","footer":"ModalUpdate_footer__127YB"};